var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1823",
    "data-name": "Rectangle 1823",
    width: 40,
    height: 40,
    fill: "#c50303",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8530",
    "data-name": "Group 8530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M33.691,17.028a1.67,1.67,0,0,0-1.67,1.67A13.354,13.354,0,1,1,18.663,5.34a14.677,14.677,0,0,1,3.173.367,1.67,1.67,0,1,0,.785-3.239A17.6,17.6,0,0,0,18.663,2a16.7,16.7,0,1,0,16.7,16.7,1.67,1.67,0,0,0-1.67-1.67Z",
    transform: "translate(0.949 1.34)",
    fill: "#c50303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M25.054,24.009a.79.79,0,0,1,0,1.145.79.79,0,0,1-1.145,0l-5.56-5.56-5.56,5.56a.79.79,0,0,1-1.145,0,.79.79,0,0,1,0-1.145l5.56-5.56-5.56-5.56a.809.809,0,1,1,1.145-1.145l5.56,5.56,5.56-5.56a.809.809,0,1,1,1.145,1.145l-5.56,5.56Z",
    transform: "translate(2.101 1.416)",
    fill: "#c50303",
    stroke: "#c50303",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/FailedIcon.6cc275165cdce1312e4c869dbc23f0df.svg";
export { ForwardRef as ReactComponent };